import * as api from '@/api';
import { getPOIResultByType } from '@/utils/poi-utils'

export async function loadMorePOIResultsWithPagination(apiType, params, poiType, response, forMap = true) {
    let data = []
    if(response.data.header) {
        const currentPosition = response.data.header.start + response.data.header.count
        if(currentPosition <= response.data.header.totalCount) {
            try {
                let totalRequestAmount = response.data.header.totalCount / response.data.header.count
                totalRequestAmount = Math.ceil(totalRequestAmount)
                for(let i = 1; i < totalRequestAmount; i++) {
                    const startPosition = i * response.data.header.count
                    const result = forMap ? await api.poi.getPOIsForMapByType(apiType, params, startPosition) : await api.poi.getPOIsForListByType(apiType, params, false, startPosition)
                    const resultData = getPOIResultByType(result, poiType);
                    data = [...data, ...resultData]
                }
            } catch(error) {
                console.error(error)
                return false
            }
        }
    }
    return data
}